import React from 'react';
import NoDataPageContainer from '../components/NoDataPageContainer';


const NoAccessPage = () => {
    const handleLogout = () => {
        localStorage.removeItem('eschool@user');
        // Redirect to the home page or login page
        window.location.href = '/';
    }

    return (
        <NoDataPageContainer
            iconClass="fa fa-lock"
            title="Access Denied"
            subtitle="You currently have no permissions assigned to access this eSchool workspace. Please contact your administrator to request access."
            actions={<>
                <button className="btn btn-outline-danger" onClick={handleLogout}>
                    Logout
                </button>&nbsp;&nbsp;
                <button className="btn btn-primary" onClick={() => window.location.href = '/'}>
                    Return Home
                </button>
                </>
            }
            />
    );
};

export default NoAccessPage;
